import { render, staticRenderFns } from "./CookieAcceptance.vue?vue&type=template&id=1663cf2d"
import script from "./CookieAcceptance.vue?vue&type=script&lang=js"
export * from "./CookieAcceptance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports